export default __webpack_public_path__ + "static/media/Remove-Snail.05757440.svg";